import {QrCodeInner} from '#/components/StarterPack/QrCode'

/**
 * Live QR for a family invite link. Uses the exact same technique as the
 * starter-pack QR (react-native-qrcode-styled + Taderok logo on top). The QR is
 * never baked into a static image — the code expires in 10 minutes and can be
 * regenerated, so we render it on demand.
 */
export function FamilyQrCode({link}: {link: string}) {
  // Center logo sits at 90% of the default size (the QR code itself needs
  // room to stay scannable — a smaller mark leaves more quiet zone).
  return <QrCodeInner link={link} logoScale={0.9} />
}
